(() => {
  const small = window.matchMedia('(max-width:749px)');
  function footerLayout(root = document) {
    root.querySelectorAll('.picky-footer-group').forEach(group => { group.open = !small.matches; });
  }
  footerLayout();
  small.addEventListener('change', () => footerLayout());
  document.addEventListener('shopify:section:load', event => footerLayout(event.target));
  document.addEventListener('click', event => {
    const summary = event.target.closest('.picky-footer-group > summary');
    if (summary && !small.matches) event.preventDefault();
    const guide = event.target.closest('a[href$="#picky-academy-guide"]');
    if (guide) document.querySelector('#picky-academy-guide details')?.setAttribute('open', '');
  });
  if (location.hash === '#paddle-compare') document.getElementById('paddle-compare')?.setAttribute('open', '');
})();
